var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M990.8,561.4c0,67-50.8,121.3-113.5,121.3c-62.7,0-113.5-54.3-113.5-121.3c0-67,50.8-121.3,113.5-121.3 S990.8,494.5,990.8,561.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.1,561.4c0,67-50.8,121.3-113.5,121.3s-113.5-54.3-113.5-121.3c0-67,50.8-121.3,113.5-121.3 S446.1,494.5,446.1,561.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M763.9,415.9c0,93.8-71.1,169.8-158.9,169.8c-87.7,0-158.9-76-158.9-169.8c0-93.8,71.1-169.8,158.9-169.8 C692.7,246.2,763.9,322.2,763.9,415.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M899.1,731.2c29.4,49,46.4,107.2,46.4,169.8v48.5c0,8.5-1.4,16.7-3.9,24.3h117.4c6,0,11.8-2.6,16-7.1 c4.3-4.5,6.7-10.7,6.7-17.1V901c0-93.8-71.1-169.8-158.9-169.8L899.1,731.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M877.4,973.7H332.6c-12.5,0-22.7-10.9-22.7-24.3V901c0-147.3,111.8-266.8,249.7-266.8h90.8 c137.9,0,249.7,119.4,249.7,266.8v48.5C900.1,962.9,889.9,973.7,877.4,973.7L877.4,973.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.9,731.2h-23.7c-87.7,0-158.9,76-158.9,169.8v48.5c0,6.4,2.4,12.6,6.7,17.1c4.2,4.6,10,7.1,16,7.1h117.4 c-2.5-7.6-3.9-15.7-3.9-24.3V901C264.5,838.5,281.6,780.2,310.9,731.2L310.9,731.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c626721079aed02de566af6003858db7.svg";
export { ForwardRef as ReactComponent };